<template>
  <div v-if="dialogVisible" class="ai-disclaimer-mask">
    <div class="ai-disclaimer-card">
      <div class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </div>
      <div class="disclaimer-content">
        <img
          class="disclaimer-content__icon"
          src="https://cdn-image.yucrm.cn/images/dyAssets/images/tip/blue_new.svg"
          alt=""
        />
        <div class="disclaimer-content__info">
          <div>本AI工具面向成年人使用，用于文案创作、信息查询辅助；</div>
          <div>基于「DeepSeek大模型」提供服务。</div>
          <div>AI生成内容仅供参考，不构成法律、医疗等专业建议。</div>
        </div>
      </div>
      <div class="disclaimer-footer">
        <label class="no-prompt-label">
          <el-checkbox v-model="noLongerPrompt"></el-checkbox>
          <span>不再提示</span>
        </label>
        <jd-button type="blue" @click="handleConfirm">我知道了</jd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { updateDisclaimerChecked } from "@/api/ai/newAi.js";
export default {
  name: "AiDisclaimerDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noLongerPrompt: false,
    };
  },
  computed: {
    ...mapGetters(["loginUserInfo"]),
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    handleConfirm() {
      this.updateFn("confirm");
    },
    handleClose() {
      this.updateFn("close");
    },
    updateFn(action) {
      const params = {
        platform: "JD",
        userId: this.loginUserInfo.platformAccountInfo.platformCompanyUserId,
      };
      if (action == "confirm") {
        params.accessType = this.noLongerPrompt ? 2 : 1;
      } else if (action == "close") {
        params.accessType = 1;
      }
      updateDisclaimerChecked(params).then((res) => {
        if (res.code == 200) {
          this.$emit("input", false);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-disclaimer-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  border-radius: inherit;
}
.ai-disclaimer-card {
  padding: 24px;
  width: 480px;
  height: 170px;
  background: #ffffff;
  border-radius: 4px;
  position: relative;
}
.disclaimer-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
}
.info-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #2962ff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #999;
  font-size: 18px;
  &:hover {
    color: #666;
  }
}
.disclaimer-content {
  display: flex;
  &__icon {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  &__info {
    font-weight: 400;
    font-size: 14px;
    color: #252931;
    line-height: 22px;
  }
}
.disclaimer-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
}
.no-prompt-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}
.confirm-btn {
  border-radius: 4px;
}
</style>
